import { useNavigate } from "react-router-dom";
import { useUserPermissions } from "../../../hooks/useUserPermissions";

export const useInicioTemplate = () => {
  const navigate = useNavigate();
  const { userStorageData } = useUserPermissions();
  const primeiroNome = userStorageData?.nome?.split(" ")[0];
  const { isUserType } = useUserPermissions();
  const isCustomsBrokers = isUserType("DESPACHANTE");

  function handleMeusAgendamentos() {
    navigate("/meus-agendamentos");
  }

  function handleNovoAgendamento() {
    const route = isCustomsBrokers
      ? "/agendamento/buscar-cliente"
      : "/agendamento";

    navigate(route);
  }

  return { primeiroNome, handleMeusAgendamentos, handleNovoAgendamento };
};
